import { useId } from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import { Checkbox } from "app/components/ui/Checkbox/Checkbox";
import { Field, FieldLabel } from "app/components/form/Field/Field";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { useSelectAllFacet } from "app/features/product/productFilters/hooks/useSelectAllFacet";

type SelectAllOption = {
	value: string | number;
	count?: number;
};

type SelectAllOptionProps = {
	filterId: string;
	options: SelectAllOption[];
	className?: string;
};

export const SelectAllOption = ({ filterId, options, className }: SelectAllOptionProps) => {
	const { checked, toggle, count } = useSelectAllFacet(filterId, options);
	const id = useId();

	return (
		<Field className={classNames("select-all-option", className)}>
			<Checkbox id={id} checked={checked} onCheckedChange={toggle} />

			<FieldLabel htmlFor={id}>
				<Typography variant={TYPOGRAPHY_VARIANTS.REGULAR} component="span">
					<FormattedMessage id="product.page.filter.select.all.label" /> ({count})
				</Typography>
			</FieldLabel>
		</Field>
	);
};
